import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "main-hero"
};
const _hoisted_2 = {
  class: "custom-container section-margin"
};
const _hoisted_3 = {
  class: "row mb-lg-5 mb-sm-2"
};
const _hoisted_4 = {
  class: "col-lg-6 col-md-6 col-sm-12"
};
const _hoisted_5 = {
  class: "plan-card"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-lg-3 col-md-3 col-sm-3 col-3"
};
const _hoisted_8 = {
  class: "icon-container"
};
const _hoisted_9 = {
  class: "icon"
};
const _hoisted_10 = {
  class: "plan-card"
};
const _hoisted_11 = {
  class: "row"
};
const _hoisted_12 = {
  class: "col-lg-3 col-md-3 col-sm-3 col-3"
};
const _hoisted_13 = {
  class: "icon-container"
};
const _hoisted_14 = {
  class: "icon"
};
const _hoisted_15 = {
  class: "plan-card"
};
const _hoisted_16 = {
  class: "row"
};
const _hoisted_17 = {
  class: "col-lg-3 col-md-3 col-sm-3 col-3"
};
const _hoisted_18 = {
  class: "icon-container"
};
const _hoisted_19 = {
  class: "icon"
};
const _hoisted_20 = {
  class: "plan-card"
};
const _hoisted_21 = {
  class: "row"
};
const _hoisted_22 = {
  class: "col-lg-3 col-md-3 col-sm-3 col-3"
};
const _hoisted_23 = {
  class: "icon-container"
};
const _hoisted_24 = {
  class: "icon"
};
const _hoisted_25 = {
  class: "col-lg-6 col-md-6 col-sm-12"
};
const _hoisted_26 = {
  class: "plan-card"
};
const _hoisted_27 = {
  class: "row"
};
const _hoisted_28 = {
  class: "col-lg-3 col-md-3 col-sm-3 col-3"
};
const _hoisted_29 = {
  class: "icon-container"
};
const _hoisted_30 = {
  class: "icon"
};
const _hoisted_31 = {
  class: "plan-card"
};
const _hoisted_32 = {
  class: "row"
};
const _hoisted_33 = {
  class: "col-lg-3 col-md-3 col-sm-3 col-3"
};
const _hoisted_34 = {
  class: "icon-container"
};
const _hoisted_35 = {
  class: "icon"
};
const _hoisted_36 = {
  class: "plan-card"
};
const _hoisted_37 = {
  class: "row"
};
const _hoisted_38 = {
  class: "col-lg-3 col-md-3 col-sm-3 col-3"
};
const _hoisted_39 = {
  class: "icon-container"
};
const _hoisted_40 = {
  class: "icon"
};
const _hoisted_41 = {
  class: "plan-card"
};
const _hoisted_42 = {
  class: "row"
};
const _hoisted_43 = {
  class: "col-lg-3 col-md-3 col-sm-3 col-3"
};
const _hoisted_44 = {
  class: "icon-container"
};
const _hoisted_45 = {
  class: "icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloudImage = _resolveComponent("CloudImage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "visit-details mb-sm-1 mb-lg-5"
  }, [_createElementVNode("h2", {
    class: "headline-2"
  }, "What our plans cover")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, [_createVNode(_component_CloudImage, {
    alt: "emergency-medical",
    imageName: "emergency-medical_ybcxgx.svg"
  })])])]), _cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "col-lg-9 col-md-9 col-sm-9 col-9"
  }, [_createElementVNode("div", {
    class: "card-body-content"
  }, [_createElementVNode("h3", null, "Emergency Medical"), _createElementVNode("p", null, "Our plans cover your unexpected medical and dental costs, regardless of where you are in the world.")])], -1))])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, [_createVNode(_component_CloudImage, {
    alt: "pre-existing-conditions",
    imageName: "pre-existing-conditions_efu9jc.svg"
  })])])]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "col-lg-9 col-md-9 col-sm-9 col-9"
  }, [_createElementVNode("div", {
    class: "card-body-content"
  }, [_createElementVNode("h3", null, "Pre-Existing Conditions"), _createElementVNode("p", null, "A plan from G1G means coverage and treatment for unexpected onset of pre-existing conditions.")])], -1))])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, [_createVNode(_component_CloudImage, {
    alt: "pre-existing-conditions",
    imageName: "covid-19_tbsoul.svg"
  })])])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "col-lg-9 col-md-9 col-sm-9 col-9"
  }, [_createElementVNode("div", {
    class: "card-body-content"
  }, [_createElementVNode("h3", null, "COVID-19"), _createElementVNode("p", null, "We make sure you are covered if new outbreaks of COVID-19 occur at your destination.")])], -1))])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, [_createVNode(_component_CloudImage, {
    alt: "pre-existing-conditions",
    imageName: "emergency-evacuation_aeezni.svg"
  })])])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "col-lg-9 col-md-9 col-sm-9 col-9"
  }, [_createElementVNode("div", {
    class: "card-body-content"
  }, [_createElementVNode("h3", null, "Emergency Evacuations"), _createElementVNode("p", null, "Emergency medical transportation when you need to get to a hospital fast, from land or sea.")])], -1))])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, [_createVNode(_component_CloudImage, {
    alt: "pre-existing-conditions",
    imageName: "flight-delays_k4usml.svg"
  })])])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "col-lg-9 col-md-9 col-sm-9 col-9"
  }, [_createElementVNode("div", {
    class: "card-body-content"
  }, [_createElementVNode("h3", null, "Flight Delays"), _createElementVNode("p", null, "Coverage for your taxi, hotel, and/or meals when your flight is delayed by 6 hours or more.")])], -1))])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("span", _hoisted_35, [_createVNode(_component_CloudImage, {
    alt: "pre-existing-conditions",
    imageName: "missed-connections_r3dmqu.svg"
  })])])]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "col-lg-9 col-md-9 col-sm-9 col-9"
  }, [_createElementVNode("div", {
    class: "card-body-content"
  }, [_createElementVNode("h3", null, "Missed Connections"), _createElementVNode("p", null, "Get caught up when you miss your connecting flight, ferry, or train by 3 hours or more.")])], -1))])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, [_createVNode(_component_CloudImage, {
    alt: "pre-existing-conditions",
    imageName: "lost-stolen-gear_nd9hiu.svg"
  })])])]), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "col-lg-9 col-md-9 col-sm-9 col-9"
  }, [_createElementVNode("div", {
    class: "card-body-content"
  }, [_createElementVNode("h3", null, "Lost / Stolen Gear"), _createElementVNode("p", null, "Our plans cover the loss, theft, or damage to your baggage and personal belongings, including cameras, phones, and more!")])], -1))])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("span", _hoisted_45, [_createVNode(_component_CloudImage, {
    alt: "pre-existing-conditions",
    imageName: "much-much-more_wjlszo.svg"
  })])])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "col-lg-9 col-md-9 col-sm-9 col-9"
  }, [_createElementVNode("div", {
    class: "card-body-content"
  }, [_createElementVNode("h3", null, "& much, much more!"), _createElementVNode("p", null, "We’ll build a travel safety package uniquely suited to wherever your adventures take you!")])], -1))])])])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "row"
  }, [_createElementVNode("div", {
    class: "col-10"
  }, [_createElementVNode("p", {
    class: "bottom-para"
  }, "Specific eligibly (time-sensitive or otherwise) criteria apply to benefits and coverage areas. Not every benefit is offered by every plan. Please check specific plan details or get in touch to make sure you can get covered! ")])], -1))])]);
}